var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.9048 0.5H2.09524C0.93807 0.5 0 1.45513 0 2.63333V14.3667C0 15.5449 0.93807 16.5 2.09524 16.5H19.9048C21.0619 16.5 22 15.5449 22 14.3667V2.63333C22 1.45513 21.0619 0.5 19.9048 0.5Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.76758H22V12.2342H0V4.76758Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42852 7.13775V9.82575C9.42852 10.5724 8.72452 11.1697 7.8571 11.1697H5.76186C4.89652 11.1676 4.19043 10.5671 4.19043 9.82362V7.13562C4.19043 6.52548 4.65976 6.01562 5.3051 5.85028C5.49995 5.29562 6.09919 5.79268 6.80948 5.79268C7.52395 5.79268 8.119 5.29882 8.31386 5.85135C8.9571 6.02095 9.42852 6.53188 9.42852 7.13775Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42854 7.9668H10.4762V11.1668H9.42854V7.9668ZM3.14282 7.9668H4.19044V11.1668H3.14282V7.9668Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42854 10.0996H10.4762V11.1663H9.42854V10.0996ZM3.14282 10.0996H4.19044V11.1663H3.14282V10.0996Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42854 6.90039H10.4762V7.96706H9.42854V6.90039ZM3.14282 6.90039H4.19044V7.96706H3.14282V6.90039Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23804 6.90039H6.28566V8.50039H5.23804V6.90039ZM7.33328 9.03372H8.38089V10.6337H7.33328V9.03372Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33325 6.90039H8.38087V8.50039H7.33325V6.90039Z",
    fill: "#AE6A3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23804 9.0332H6.28566V10.6332H5.23804V9.0332Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28566 6.90065L5.23804 5.83398H8.38089L7.33328 6.90065H6.28566Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28564 4.76758H7.33326V5.83424H6.28564V4.76758Z",
    fill: "#D4AF2C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4315_2182"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.a7d49c71db49fb582fc511e6f22987b9.svg";
export { ForwardRef as ReactComponent };